import { IFormErrorHandler } from "../../../common/Form/FormError";
import { IApiError409, IApiError422 } from "../../api/types";

export const uniqueEmailHandler: IFormErrorHandler = {
  match: (error: IApiError409 | IApiError422) => 
    error.meta.validationFailure.attributeName === 'emailAddress' &&
    error.meta.validationFailure.predicateType === 'isUnique',
  describe: (error: IApiError409 | IApiError422) => `A user with the given email address already exists ("${error.meta.validationFailure.attributeValue}")`,
}
